import { KeyedMutator } from 'swr';

export type Request = {
  url: string;
  method?: string;
  headers?: { [key: string]: string };
  body?: string;
  responseType?: 'json' | 'text';
  baseUrl?: string;
};

export type Response<Data = any> = {
  ok: boolean | undefined;
  status: number | undefined;
  data: Data | null | undefined;
  error: string | null;
  mutate: KeyedMutator<Response<Data>>;
  isValidating: boolean;
  isLoading: boolean;
};

export enum FETCH_STATUS {
  IDLE = 'Idle',
  FETCHING = 'Fetching',
  SUCCESS = 'Success',
  ERROR = 'Error',
}
